/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BranchType } from '../models/BranchType';
import type { VHCAdvisorQuoteStatisticsDto } from '../models/VHCAdvisorQuoteStatisticsDto';
import type { VHCBranchSummaryStatisticsDto } from '../models/VHCBranchSummaryStatisticsDto';
import type { VHCCompletionReportDto } from '../models/VHCCompletionReportDto';
import type { VHCQuoteStatsBranchSummaryStatisticsDto } from '../models/VHCQuoteStatsBranchSummaryStatisticsDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class VhcStatisticsService {

  /**
   * @param dateFrom 
   * @param dateTo 
   * @param branch 
   * @returns VHCBranchSummaryStatisticsDto Success
   * @throws ApiError
   */
  public static getVhcStatisticsBranchSummary(
dateFrom?: string,
dateTo?: string,
branch?: Array<BranchType>,
): CancelablePromise<Array<VHCBranchSummaryStatisticsDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/vhc-statistics/branch-summary',
      query: {
        'DateFrom': dateFrom,
        'DateTo': dateTo,
        'Branch': branch,
      },
    });
  }

  /**
   * @param dateFrom 
   * @param dateTo 
   * @param branch 
   * @returns VHCBranchSummaryStatisticsDto Success
   * @throws ApiError
   */
  public static getVhcStatisticsAdvisorsReport(
dateFrom?: string,
dateTo?: string,
branch?: Array<BranchType>,
): CancelablePromise<Array<VHCBranchSummaryStatisticsDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/vhc-statistics/advisors-report',
      query: {
        'DateFrom': dateFrom,
        'DateTo': dateTo,
        'Branch': branch,
      },
    });
  }

  /**
   * @param dateFrom 
   * @param dateTo 
   * @param branch 
   * @returns VHCCompletionReportDto Success
   * @throws ApiError
   */
  public static getVhcStatisticsCompletionReport(
dateFrom?: string,
dateTo?: string,
branch?: Array<BranchType>,
): CancelablePromise<Array<VHCCompletionReportDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/vhc-statistics/completion-report',
      query: {
        'DateFrom': dateFrom,
        'DateTo': dateTo,
        'Branch': branch,
      },
    });
  }

  /**
   * @param dateFrom 
   * @param dateTo 
   * @param branch 
   * @returns VHCQuoteStatsBranchSummaryStatisticsDto Success
   * @throws ApiError
   */
  public static getVhcStatisticsQuoteStatsBranchSummary(
dateFrom?: string,
dateTo?: string,
branch?: Array<BranchType>,
): CancelablePromise<Array<VHCQuoteStatsBranchSummaryStatisticsDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/vhc-statistics/quote-stats-branch-summary',
      query: {
        'DateFrom': dateFrom,
        'DateTo': dateTo,
        'Branch': branch,
      },
    });
  }

  /**
   * @param dateFrom 
   * @param dateTo 
   * @param branch 
   * @returns VHCQuoteStatsBranchSummaryStatisticsDto Success
   * @throws ApiError
   */
  public static getVhcStatisticsQuoteStatsAdvisorsReport(
dateFrom?: string,
dateTo?: string,
branch?: Array<BranchType>,
): CancelablePromise<Array<VHCQuoteStatsBranchSummaryStatisticsDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/vhc-statistics/quote-stats-advisors-report',
      query: {
        'DateFrom': dateFrom,
        'DateTo': dateTo,
        'Branch': branch,
      },
    });
  }

  /**
   * @param dateFrom 
   * @param dateTo 
   * @param branch 
   * @returns VHCAdvisorQuoteStatisticsDto Success
   * @throws ApiError
   */
  public static getVhcStatisticsAdvisorsReportCsv(
dateFrom?: string,
dateTo?: string,
branch?: Array<BranchType>,
): CancelablePromise<Array<VHCAdvisorQuoteStatisticsDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/vhc-statistics/advisors-report-csv',
      query: {
        'DateFrom': dateFrom,
        'DateTo': dateTo,
        'Branch': branch,
      },
    });
  }

}
